import { render } from "./OriGamma.vue?vue&type=template&id=3afb5e40"
import script from "./OriGamma.vue?vue&type=script&lang=js"
export * from "./OriGamma.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__